import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SERecognitionNew from "../../components/services/secondaryEducation/SERecognitionNew";

const SERecognitionNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <SERecognitionNew />
    </PageWrapper>
  );
};

export default SERecognitionNewPage;
